export const SecurityQuestions = [
    { text: 'What was your childhood nickname?', value: 1 },
    { text: 'In what city did you meet your spouse/significant other?', value: 2 },
    { text: 'What is the name of your favorite childhood friend?', value: 3 },
    { text: 'In what city or town did your mother and father meet?', value: 4 },
    { text: 'In what city or town was your first job?', value: 5 },
    { text: 'Who was your childhood hero?', value: 6 },
    { text: 'In what city and country do you want to retire?', value:  7},
    { text: 'What is the name of the first school you attended?', value: 8 },
]